"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = exports.EOL = void 0;
exports.EOL = '\r\n';
exports.defaultOptions = { maxLength: 120, references: [] };
//# sourceMappingURL=constants.js.map